import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_InternalServerError = _resolveComponent("InternalServerError")!

  return (_openBlock(), _createBlock(_component_InternalServerError, null, {
    default: _withCtx(() => [
      _createVNode(_component_BaseButton, {
        buttonClass: "outlined",
        class: "mt-5",
        onClick: _ctx.handleGoMyPage
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(" マイページに戻る ", -1)
        ]))]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  }))
}